<template>
  <section class="mt-5 md:mx-4.5 md:mt-12" data-testid="contact-section">
    <div
      class="mx-auto max-w-content-container overflow-hidden md:flex md:rounded-t-xl"
    >
      <div class="relative overflow-hidden px-4.5 py-16 md:w-1/2 md:px-12">
        <img
          class="absolute inset-0 size-[300%] object-cover object-[-24rem_-16rem] sm:size-full sm:object-top"
          src="https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,f_auto/v1744123685/assets/ice/ice-common/80aae3211fe3296b337631b752255192_iu8bjk.png"
          alt=""
          aria-hidden
        />

        <!-- Overlay -->
        <div class="absolute inset-0 size-full bg-black/40 md:bg-black/60" />

        <p
          class="relative max-w-[14rem] text-h2 text-white sm:max-w-none md:text-mega"
        >
          Questions? We can help, contact us
        </p>
      </div>

      <div class="flex items-center md:w-1/2">
        <div class="h-full w-full bg-grey-900 px-4.5 py-5 md:px-12 md:py-10">
          <div
            class="flex max-w-[34rem] flex-col gap-y-5 text-paragraph-xl text-white md:text-paragraph-xxl"
          >
            <slot />
          </div>

          <ButtonContactUs
            class="mt-5 hidden w-full md:block md:w-fit"
            text="Contact Us"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
</script>
